import React from 'react';
import Icon from '../../../components/AppIcon';

const ClientBenefits = () => {
  const benefits = [
    {
      icon: 'Scale',
      title: 'Strategic Litigation',
      description: 'Comprehensive case strategy development that maximizes your chances of success while minimizing risks and costs associated with litigation.'
    },
    {
      icon: 'Users',
      title: 'Courtroom Experience',
      description: 'Seasoned trial attorneys with extensive courtroom experience who provide skilled advocacy and professional representation.'
    },
    {
      icon: 'Handshake',
      title: 'Settlement Negotiation',
      description: 'Expert negotiation skills that often achieve favorable settlements without the need for lengthy and costly trial proceedings.'
    },
    {
      icon: 'Clock',
      title: 'Efficient Resolution',
      description: 'Streamlined litigation processes focused on achieving timely resolutions while maintaining the highest standards of legal representation.'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
            Our Litigation Process
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            A structured approach to civil litigation that ensures comprehensive representation and strategic advocacy at every stage.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-primary to-accent rounded-xl flex items-center justify-center">
                <Icon name={benefit.icon} size={24} color="white" strokeWidth={2} />
              </div>
              <div>
                <h3 className="text-xl font-heading font-semibold text-text-primary mb-3">
                  {benefit.title}
                </h3>
                <p className="text-text-secondary leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Litigation Process */}
        <div className="bg-gradient-to-br from-surface/20 to-primary/5 rounded-2xl p-8 border border-primary/10">
          <h3 className="text-2xl font-heading font-semibold text-text-primary mb-6 text-center">
            Litigation Process Overview
          </h3>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Icon name="Search" size={24} color="white" strokeWidth={2} />
              </div>
              <h4 className="text-lg font-heading font-semibold text-text-primary mb-2">
                Case Assessment
              </h4>
              <p className="text-text-secondary text-sm">
                Thorough evaluation of your case merits and potential outcomes.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-accent rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Icon name="Target" size={24} color="white" strokeWidth={2} />
              </div>
              <h4 className="text-lg font-heading font-semibold text-text-primary mb-2">
                Strategy Development
              </h4>
              <p className="text-text-secondary text-sm">
                Comprehensive litigation strategy tailored to your specific case.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-secondary rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Icon name="FileText" size={24} color="white" strokeWidth={2} />
              </div>
              <h4 className="text-lg font-heading font-semibold text-text-primary mb-2">
                Discovery Process
              </h4>
              <p className="text-text-secondary text-sm">
                Thorough evidence gathering and case preparation procedures.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Icon name="Scale" size={24} color="white" strokeWidth={2} />
              </div>
              <h4 className="text-lg font-heading font-semibold text-text-primary mb-2">
                Trial Preparation
              </h4>
              <p className="text-text-secondary text-sm">
                Comprehensive preparation for trial proceedings and advocacy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientBenefits;